import React,{useState,useEffect,useRef} from 'react';
import styled from 'styled-components'
import cn from 'classnames'
// import ScrollHorizontal from 'react-scroll-horizontal';
// import ScrollMenu from 'react-horizontal-scrolling-menu' 

const Article3Block = styled.div`
  height: 5000px;
  position: relative;
  background: #555;
  /* background-image: url('images/bg02.png'); */
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  z-index: -1;
  &::before {
    content: '';
    position: absolute;
    top: 0; left: 0;
    width: 100%;
    height: 100%;
    /* background: rgba(0,0,0,.3); */
  }
  .out {
    width: 100vw;
    height: 100vh;
    position: relative;
    h1 {
      position: absolute;
      font-size: 70px;
      top:0%; left: -100vh; 
      transform:  rotate(-90deg) ;
      transform-origin: right top;
      width: 100vh;
      height: 100px;
      line-height: 100px;
      text-align: center;
      color: #fff;
      background: linear-gradient(to left, #000000, #434343);
      font-family: 'Josefin Sans';
      z-index: 9;
    }
    .tape {
      position: absolute;
      bottom: 0; right: 0;
      width: 200px;
      z-index: 9;
      transform: rotate(-30deg);
    }
    &.on {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
    }
    .inner {
      position: absolute;
      display: flex;
      padding: 100px;
      width: 6000px;
      height: 100%;
      top: 0;
      left: 0;
      h2 { font-family: 'Josefin Sans'; font-size:90px; }
      .row1 {
        width: 1000px;
        position: relative;
        h2 {
          position: absolute;
          top: 0; right: 0;
          mix-blend-mode: difference;
        }
        .cdg {
          width: 500px;
        }
        .cdgPerfume {
          width: 250px;
          transform: translate(-150px,170px);
        }
        .cdgwalk {
          width: 250px;
          position: absolute;
          top: 150px; right: 0;
        }
      }
      .row2 {
        margin-left: 300px;
        display: flex;
        align-items: center;
        position: relative;
        .flexBox {
          h2 {
            position: absolute;
            top: 0; right: 50px;
            color: #fff;
          }
          span {
            font-family: 'Josefin Sans';
            position: absolute;
            top: 100px; right: 50px;
            font-size: 30px;
          }
          img {
            width: 500px;
          }
          .vans2 {
            transform: translate(-50px,100px);
          }
          .vans3 {
            position: absolute;
            width: 200px;
            top: 420px;
            right: -50px;
            animation:twist 1s linear infinite alternate;
          }
          @keyframes twist{
            0% {transform:rotate(0deg);}
            100% {transform:rotate(15deg);}
          }
        }
      }
      .row3 {
        margin-left: 300px;
        position: relative;
        width: 1100px;
        h2 {
        }
        .nike1 {
          width:800px;
          
        }
        .nike2 {
          width:300px;
          transform: translate(-100px,-200px);
        }
        .nikegif {
          width: 200px;
          position:absolute;
          top: 50%; right: 50px;
        }
      }
      .row4 {
        margin-left: 300px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        width: 800px;
        .dior {
          width: 800px;
        }
      }
    }
  }
`;



const Article3 = (props) => {

  const { art1height } = props;
  
  const thisTop = useRef();
  const innerDivRef = useRef(null);
  const [on, setOn] = useState(false);

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  },[art1height]);
  
  const onScroll = () => {
    if (innerDivRef.current) {
      innerDivRef.current.style.transform = `translateX(-${window.scrollY}px)`;
      innerDivRef.current.style.marginLeft = `${art1height + 2800}px`;
    }
    if (thisTop.current.offsetTop <= window.scrollY && thisTop.current.offsetTop + 5000 >= window.scrollY ) {
      setOn(true);
    }else {
      setOn(false);
    }
  }


  return (
      <Article3Block ref={thisTop}>
        <img src="images/checkpattern.gif" alt="cdg stussy" style={{width:'400px',position:'absolute',top:'0',left:'0',transform:'translate(400px,1500px)'}}/>
        <div className={cn({on},'out')}>
          <h1 className='mainTitle'>Colaborated</h1>
          <img className='tape' src="images/greytape.png" alt="tape object"/>
          <div 
            className='inner' 
            ref={innerDivRef}
          >
            <div className='row1'>
              <h2>Commdes des Garcons</h2>
              <img className='cdg' src="images/CDGxstussy.jpeg" alt="cdg stussy"/>
              <img className='cdgPerfume' src="images/CDGPerfume.png" alt="cdg stussy perfume"/>
              <img className='cdgwalk' src="images/cdgXstussycolabo.jpeg" alt="cdg stillshot"/>
            </div>
            <div className='row2'>
              <div className='flexBox'>
                <h2>VANS</h2>
                <span>Color : Pink</span>
                <img className='vans1' src="images/vansXstussy.jpeg" alt="vans"/>
                <img className='vans2' src="images/vansXstussy2.jpeg" alt="vans"/>
                <img className='vans3' src="images/vansSticker.png" alt="vans"/>
              </div>
            </div>
            <div className='row3'>
              <h2>NIKE</h2>
              <img className='nike1' src="images/nikeXstussy.jpeg" alt="nike"/>
              <img className='nike2' src="images/nikeXstussy4.jpeg" alt="nike"/>
              <img className='nikegif' src="images/nikegif.gif" alt="nike"/>
            </div>
            <div className='row4'>
              <h2>Christian Dior</h2>
              <img className='dior' src="images/dior_stussy.jpeg" alt="dior"/>
            </div>
          </div>
        </div>
      </Article3Block>
  );
};

export default Article3;